import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { messaging } from '../helpers';
import {
  notifications as notificationsActions,
  profile as profileActions,
} from './../actions';
import {
  getNotificationRules,
  notificationRequestsByRuleId,
  profileReducer
} from '../reducers';
import NotificationsComponent from '../Components/NotificationsComponent';

export const mapStateToProps = (state) => {
  return {
    showFavoritesOnly: profileReducer.getProfileFavoritesOnly(state),
    notificationRequestsByRuleId: notificationRequestsByRuleId(state),
    notificationRules: getNotificationRules(state)
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    subscribe: async (formData) => {
      const result = await dispatch(notificationsActions.subscribe(formData));
      if (result) {
        toastr.success(messaging.NOTIFICATION_SUCCESS);
      }
      else {
        toastr.error(messaging.NOTIFICATION_FAILURE);
      }
    },
    toggleFavoritesOnly: () => dispatch(profileActions.toggleProfileFavorites()),
    unsubscribe: async (formData) => {
      const result = await dispatch(notificationsActions.unsubscribe(formData));
      if (result) {
        toastr.success(messaging.NOTIFICATION_SUCCESS);
      }
      else {
        toastr.error(messaging.NOTIFICATION_FAILURE);
      }
    }
  };
};

const NotificationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationsComponent);

export default NotificationsContainer;


// WEBPACK FOOTER //
// src/Containers/NotificationsContainer.jsx